module.exports = __webpack_public_path__ + "img/holidayGreetings.5a7805c4.png";